import { ContextGLBlendFactor } from '../base/ContextGLBlendFactor';
import { ContextGLTriangleFace } from '../base/ContextGLTriangleFace';
import { ContextGLClearMask } from '../base/ContextGLClearMask';
var FilterBase = /** @class */ (function () {
    function FilterBase() {
        this._tasks = [];
        this._temp = [];
        this._activeTaskIndex = -1;
    }
    Object.defineProperty(FilterBase.prototype, "isValid", {
        get: function () {
            for (var _i = 0, _a = this._tasks; _i < _a.length; _i++) {
                var t = _a[_i];
                if (!t.isValid) {
                    return false;
                }
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterBase.prototype, "requireBlend", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterBase.prototype, "blendDst", {
        get: function () {
            return ContextGLBlendFactor.ZERO;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterBase.prototype, "blendSrc", {
        get: function () {
            return ContextGLBlendFactor.ONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterBase.prototype, "requireDepthRender", {
        get: function () {
            return this._requireDepthRender;
        },
        enumerable: false,
        configurable: true
    });
    FilterBase.prototype.addTask = function (filter) {
        this._tasks.push(filter);
        if (this._requireDepthRender == null)
            this._requireDepthRender = filter.requireDepthRender;
    };
    FilterBase.prototype.removeTask = function (filter) {
        var index = this._tasks.indexOf(filter);
        if (index === -1) {
            return;
        }
        this._tasks.slice(index, 1);
    };
    /**
     * Query next task while this possible, real task-passes can be greater that task count (multipassed blur)
     */
    FilterBase.prototype.nextTask = function () {
        return this._activeTaskIndex < this._tasks.length
            ? this._tasks[++this._activeTaskIndex]
            : null;
    };
    FilterBase.prototype.hasNextTask = function () {
        return this._tasks.length < this._activeTaskIndex;
    };
    FilterBase.prototype.meashurePad = function (input, target) {
        if (target === void 0) { target = input.clone(); }
        if (input === target)
            return target;
        target.copyFrom(input);
        return target;
    };
    FilterBase.prototype.apply = function (source, target, sourceRect, destRect, filterManager, clearOutput) {
        if (clearOutput === void 0) { clearOutput = false; }
        var stage = filterManager.stage;
        var context = stage.context;
        this.setRenderState(source, target, sourceRect, destRect, filterManager);
        // context will enable blend when it was changed
        context.setBlendFactors(this.blendSrc, this.blendDst);
        context.setBlendState(this.requireBlend);
        context.setCulling(ContextGLTriangleFace.NONE);
        var task;
        // target image has MSAA
        var msaa = context.glVersion === 2;
        // iterate while filter have tasks
        while ((task = this.nextTask())) {
            task.preActivate(filterManager.stage);
            stage.setRenderTarget(task.target, true, 0, 0, true);
            stage.setScissor(task.destRect);
            stage.context.disableStencil();
            // because we use TMP image, need clear it
            // but this is needed only when a blend composer is required, when a copy filter used
            // or when required by filter chain, clear output for end task
            if (source === target && this.requireBlend || task.needClear || clearOutput && !this.hasNextTask()) {
                context.clear(0, 0, 0, 0, 1, 0, ContextGLClearMask.ALL);
            }
            filterManager.drawTask(task);
        }
        this.clear(filterManager);
    };
    // link up the filters correctly with the next filter
    FilterBase.prototype.setRenderState = function (source, mainTarget, sourceRect, destRect, filterManager) {
        this._activeTaskIndex = -1;
        this._tasks[0].inputRect = sourceRect;
        this._tasks[0].source = source;
        this._tasks[this._tasks.length - 1].destRect = destRect;
        this._tasks[this._tasks.length - 1].target = mainTarget;
    };
    FilterBase.prototype.dispose = function () {
        for (var _i = 0, _a = this._tasks; _i < _a.length; _i++) {
            var task = _a[_i];
            task.dispose();
        }
        this._tasks.length = 0;
    };
    FilterBase.prototype.update = function (_stage, _projection) {
    };
    FilterBase.prototype.clear = function (_manager) {
        for (var _i = 0, _a = this._temp; _i < _a.length; _i++) {
            var image = _a[_i];
            _manager.pushTemp(image);
        }
        this._temp.length = 0;
        this._activeTaskIndex = -1;
        this.imageScale = 1;
    };
    return FilterBase;
}());
export { FilterBase };
